import SubscriptionTypeInfo from '@/components/subscriptiontypes/Info';
export default {
  name: 'Info',
  components: {
    SubscriptionTypeInfo
  },
  props: {
    subscription: Object
  },
  filters: {
    billingType: function (value) {
      return value > 1 ? 'Annually' : value ? 'Monthly' : 'Once';
    }
  }
};